'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var parseDataAttributes = require('../../parseDataAttributes-81c8dbee.js');
require('../../SymbolsCounter.style-64b0606b.js');
var react = require('@emotion/react');
var SymbolsCounter = require('../../SymbolsCounter-ac370612.js');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');
var theme_emotionUtils = require('../../theme/emotionUtils.js');
var Paragraph = require('../../Paragraph-284fa117.js');
var Row = require('../../Row-e4fe5862.js');
require('lodash/fp/fromPairs');
require('lodash/fp/map');
require('lodash/fp/toPairs');
require('lodash/fp/flow');
require('../Icon/icons/default/Warning.js');
require('../../withIconProps-365ff8d5.js');
require('@styled-system/should-forward-prop');
require('styled-system');
require('../Icon/icons/default/Tick.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Label = styled__default["default"]('label', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'required';
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    color: ", ";\n    cursor: pointer;\n    display: block;\n    font-size: ", ";\n    line-height: 1;\n    margin-bottom: ", ";\n\n    ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['text-global-primary'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.p3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space[4];
}, function (_ref4) {
  var required = _ref4.required;
  return required && theme_emotionUtils.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n            &::after {\n                content: '*';\n                margin-left: 3px;\n            }\n        "])));
});
var Hint = styled__default["default"](Paragraph.P4)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n    color: ", ";\n    flex: 1;\n"])), function (_ref5) {
  var theme = _ref5.theme,
    hasError = _ref5.hasError;
  return hasError ? theme.colors['text-global-error'] : theme.colors['text-global-secondary'];
});
var RowStyled = styled__default["default"](Row.Row)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral__default["default"](["\n    flex-wrap: nowrap;\n    gap: ", ";\n    margin-top: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.space[4];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space[4];
});

var _excluded = ["label", "hint", "error", "inputProps", "inputComponent", "labelComponent", "enableRequiredIndicator", "className", "dataAttributes", "innerRef"],
  _excluded2 = ["showSymbolsCount", "validationStatus"];
var FormControlInner = function FormControlInner(_ref, ref) {
  var label = _ref.label,
    hint = _ref.hint,
    error = _ref.error,
    _ref$inputProps = _ref.inputProps,
    inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
    inputComponent = _ref.inputComponent,
    _ref$labelComponent = _ref.labelComponent,
    Label$1 = _ref$labelComponent === void 0 ? Label : _ref$labelComponent,
    _ref$enableRequiredIn = _ref.enableRequiredIndicator,
    enableRequiredIndicator = _ref$enableRequiredIn === void 0 ? false : _ref$enableRequiredIn,
    className = _ref.className,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    innerRef = _ref.innerRef,
    nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  var Input = inputComponent;
  var _inputProps$showSymbo = inputProps.showSymbolsCount,
    showSymbolsCount = _inputProps$showSymbo === void 0 ? false : _inputProps$showSymbo,
    validationStatus = inputProps.validationStatus,
    inputPropsToPass = _objectWithoutProperties__default["default"](inputProps, _excluded2);
  var _useState = React.useState((inputProps === null || inputProps === void 0 ? void 0 : inputProps.value) || (inputProps === null || inputProps === void 0 ? void 0 : inputProps.defaultValue) || ''),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var getInputValue = function getInputValue(event) {
    var _event$nativeEvent$ta;
    var value = (_event$nativeEvent$ta = event.nativeEvent.target) === null || _event$nativeEvent$ta === void 0 ? void 0 : _event$nativeEvent$ta.value;
    setInputValue(value);
  };
  var shouldDisplayHint = error || hint || showSymbolsCount;
  var vStatus = validationStatus || (!!error ? 'hasError' : undefined);
  return react.jsx("div", _extends__default["default"]({}, nativeProps, parseDataAttributes.parseDataAttributes(dataAttributes), {
    ref: ref || innerRef,
    className: className,
    onChange: getInputValue
  }), label && react.jsx(Label$1, {
    htmlFor: inputProps.id,
    required: enableRequiredIndicator && inputPropsToPass.required
  }, label), react.jsx(Input, _extends__default["default"]({}, inputPropsToPass, {
    validationStatus: vStatus
  })), shouldDisplayHint && react.jsx(RowStyled, null, react.jsx(Hint, {
    hasError: !!error
  }, error || hint || ''), showSymbolsCount && react.jsx(SymbolsCounter.SymbolsCounter, {
    maxLength: inputPropsToPass.maxLength,
    value: inputValue
  })));
};
var FormControl = /*#__PURE__*/React__default["default"].forwardRef(FormControlInner);

var FormControlLabel = Label;

exports.FormControl = FormControl;
exports.FormControlLabel = FormControlLabel;
//# sourceMappingURL=index.js.map
